import type { FaireProductEntity } from "../../entity_types/product";

export const p_4r8zzb23zw: FaireProductEntity = {
  token: "p_4r8zzb23zw",
  type: "product",
  name: "When In Doubt Take A Nap Hanging Decor",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/6e0264cd5d3f8fbc39839312bb30afbbbe8cab9d96028ea507440768768d9514.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6609ea6739816c9343ba68f8c1f5d5c4db7c8c07fafdcea690bc1f74314a9c3c.jpeg",
    "https://cdn.faire.com/fastly/48ed03a561f6619e4a8d9f8842213f8c0ca211b8ff069777f9c6b2ab3b44ade7.jpeg",
    "https://cdn.faire.com/fastly/3c2d7d28231284bf37aab7a43c33791e0ebb76d8ded2527cf994ab9efee12da1.jpeg"
  ],
  priceDollars: 5,
  description: "A ready to hang metal tin sign from our Slow Living Collection displaying a fun sentiment that reads \"When In Doubt Take A Nap\" perfect for those who enjoy cozy home life. Cozy living sign features metal with embossed details for added dimension. Our Take A Nap metal wall décor is easy to hang against wall using the included mounting hardware and pre-drilled holes. A cozy living home accent that easily adds personality to any space.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:26.581Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
